import React, { useMemo } from "react";
import { useVM } from "@src/hooks/useVM";
import { makeAutoObservable } from "mobx";
import { RootStore, useStores } from "@stores";
import { IToken, POOLS, TOKENS_LIST } from "@src/constants";

const ctx = React.createContext<MarketPageVM | null>(null);

interface IProps {
  marketId?: string;
  children: React.ReactNode;
}

export const MarketPageVMProvider: React.FC<IProps> = ({ children, marketId }) => {
  const rootStore = useStores();
  const store = useMemo(
    () => new MarketPageVM(rootStore, marketId),
    [marketId, rootStore]
  );
  return <ctx.Provider value={store}>{children}</ctx.Provider>;
};

export const useMarketPageVM = () => useVM(ctx);

class MarketPageVM {
  public readonly marketId: string;
  public rootStore: RootStore;
  searchValue = "";
  setSearchValue = (v: string) => (this.searchValue = v);

  tokens: IToken[] = TOKENS_LIST.slice(0, 5);

  sortApy = true;
  setSortApy = (v: boolean) => (this.sortApy = v);

  sortLiquidity = true;
  setSortLiquidity = (v: boolean) => (this.sortLiquidity = v);

  poolCategoryFilter = 0;
  setPoolCategoryFilter = (v: number) => (this.poolCategoryFilter = v);

  customPoolFilter = 0;
  setCustomPoolFilter = (v: number) => (this.customPoolFilter = v);

  constructor(rootStore: RootStore, marketId?: string) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
    this.marketId = marketId ?? POOLS[0].address;
    const market = POOLS.find((pool) => pool.address === this.marketId)!;
    //todo fix rename to market
    this.rootStore.lendStore.setPool(market);
  }
}
